  // src/pages/ClientDashboard/ClientDashboard.jsx
  import { useEffect, useState } from "react";
  // import { useTheme } from "../../context/ThemeContext";
  import { useClientTheme } from "../../context/ClientThemeContext";
  import EmployeeCard from "../EmployeeCard/EmployeeCard";
  import CalendarScheduler from "../../components/CalendarScheduler";
  import "./ClientDashboard.css";
  import Logo from "../../assets/Two Seas Logo.png";

  // Icons
  import {
    FiUsers,
    FiHeart,
    FiCalendar,
    FiChevronDown,
    FiRefreshCcw,
    FiMenu,
    FiX,
  } from "react-icons/fi";
  import {
    doc,
    getDoc,
    getDocs,
    addDoc,
    collection,
    db,
    deleteDoc,
  } from "../../firebase";
  import { onSnapshot, query, setDoc, where, orderBy } from "firebase/firestore";
  import EmployeeDetail from "../../components/EmployeeDetail/EmployeeDetail";
  import { LogOut } from "lucide-react";
  import { useNavigate } from "react-router-dom";

  export default function ClientDashboard() {
    const { theme, changeTheme } = useClientTheme();
    const [activeTab, setActiveTab] = useState("employees");
    const [isThemeDropdownOpen, setIsThemeDropdownOpen] = useState(false);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
    const [activeMenuItem, setActiveMenuItem] = useState("employees");
    const navigate = useNavigate();
    const [interviews, setInterviews] = useState([]);

      useEffect(() => {
      const clientUser = localStorage.getItem("clientUser");

      if (!clientUser) {
        // Only redirect to login if NOT on dashboard and NOT logged in
        if (!window.location.pathname.includes("/client-dashboard")) {
          navigate("/client-login");
        }
      } else {
        // If logged in and somehow on wrong page, redirect to dashboard
        if (!window.location.pathname.includes("/client-dashboard")) {
          navigate("/client-dashboard");
        }
      }
    }, [navigate]);

    // ✅ BETTER FIX: Only redirect if not logged in AND trying to access dashboard
    useEffect(() => {
      const clientUser = localStorage.getItem("clientUser");

      if (!clientUser && window.location.pathname === "/client-dashboard") {
        navigate("/client-login");
      }
    }, [navigate]);

    // ✅ ADD THIS: Real-time client status monitoring for automatic logout
    useEffect(() => {
      const clientUser = JSON.parse(localStorage.getItem("clientUser"));

      if (!clientUser || !clientUser.clientId) {
        navigate("/client-login");
        return;
      }

      // Listen to the client document for status changes
      const unsubscribe = onSnapshot(
        doc(db, "clients", clientUser.clientId),
        (docSnapshot) => {
          if (docSnapshot.exists()) {
            const clientData = docSnapshot.data();

            // If client status is inactive, force logout
            if (clientData.status === "Inactive") {
              handleForcedLogout();
            }
          } else {
            // If client document doesn't exist, log out
            handleForcedLogout();
          }
        },
        (error) => {
          console.error("Error listening to client status:", error);
        }
      );

      return () => unsubscribe();
    }, [navigate]);

    
    useEffect(() => {
      const storedUser = JSON.parse(localStorage.getItem("clientUser"));
      if (!storedUser || !storedUser.email) return;

      const interviewsRef = collection(db, "scheduledInterviews");

      // Use simple query without orderBy for now
      const q = query(
        interviewsRef,
        where("clientUserEmail", "==", storedUser.email)
      );

      const unsubscribe = onSnapshot(
        q,
        (snapshot) => {
          const data = snapshot.docs.map((doc) => {
            const docData = doc.data();
            return {
              id: doc.id,
              ...docData,
              createdAt: docData.createdAt?.toDate?.() || docData.createdAt,
            };
          });

          // Manual sorting - this will put latest interviews at the top
          const sortedData = data.sort((a, b) => {
            const dateA = new Date(a.createdAt);
            const dateB = new Date(b.createdAt);
            return dateB - dateA; // newest first (descending)
          });

          setInterviews(sortedData);
          console.log(`✅ Loaded ${sortedData.length} interviews, latest first`);
        },
        (error) => {
          console.error("Error fetching interviews:", error);
        }
      );

      return () => unsubscribe();
    }, []);


    // const formatDateTime = (date, time, timezone) => {
    //   if (!date || !time) return "Not set";

    //   // Format date
    //   const dateObj = new Date(date);
    //   const formattedDate = dateObj.toLocaleDateString("en-US", {
    //     year: "numeric",
    //     month: "short",
    //     day: "numeric",
    //   });

    //   // Format time with AM/PM
    //   let formattedTime = time;
    //   try {
    //     const [hours, minutes] = time.split(":").map(Number);
    //     const dateTime = new Date();
    //     dateTime.setHours(hours);
    //     dateTime.setMinutes(minutes || 0);
    //     formattedTime = dateTime.toLocaleTimeString("en-US", {
    //       hour: "numeric",
    //       minute: "2-digit",
    //       hour12: true,
    //     });
    //   } catch {
    //     formattedTime = time;
    //   }

    //   // Timezone abbreviation
    //   const timezoneAbbr =
    //     timezone?.split("/")?.pop()?.replace("_", " ") || timezone;

    //   return `${formattedDate} ${formattedTime} (${timezoneAbbr})`;
    // };

  const formatDateTime = (date, time, timezone, displayTime) => {
    if (!date || !time) return "Not set";

    // Format date
    const dateObj = new Date(date);
    const formattedDate = dateObj.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });

    // ✅ PREFER displayTime if available (from stored display format)
    let formattedTime = displayTime || time;

    // Only convert if we don't have displayTime
    if (!displayTime) {
      try {
        const [hours, minutes] = time.split(":").map(Number);
        const dateTime = new Date();
        dateTime.setHours(hours);
        dateTime.setMinutes(minutes || 0);
        formattedTime = dateTime.toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        });
      } catch {
        formattedTime = time;
      }
    }

    // Timezone abbreviation
    const timezoneAbbr =
      timezone?.split("/")?.pop()?.replace("_", " ") || timezone;

    return `${formattedDate} ${formattedTime} (${timezoneAbbr})`;
  };


    const [recommendedEmployees, setRecommendedEmployees] = useState([]);

    
    useEffect(() => {
      const storedUser = JSON.parse(localStorage.getItem("clientUser"));
      if (!storedUser?.clientId) return;

      const clientRef = doc(db, "clients", storedUser.clientId);

      // Real-time listener
      const unsubscribe = onSnapshot(
        clientRef,
        (docSnapshot) => {
          if (docSnapshot.exists()) {
            const clientData = docSnapshot.data();
            setRecommendedEmployees(clientData.recommendedEmployees || []);
            console.log(
              "✅ Recommended employees updated in real-time:",
              clientData.recommendedEmployees || []
            );
          }
        },
        (error) => {
          console.error("❌ Error listening to recommended employees:", error);
        }
      );

      // Cleanup listener on unmount
      return () => unsubscribe();
    }, []);

    const handleLogout = () => {
      localStorage.removeItem("clientUser");
      localStorage.removeItem("clientUserEmail");
      navigate("/client-login"); // Redirect to client login page
    };

    // ✅ ADD THIS: Enhanced forced logout function for automatic logout
    const handleForcedLogout = () => {
      // Clear local storage
      localStorage.removeItem("clientUser");
      localStorage.removeItem("clientUserEmail");

      // Show a message to the user
      alert("Your account has been deactivated. Please contact administrator.");

      // Redirect to login
      navigate("/client-login");
    };

    // Store client info from localStorage
    const [clientUser, setClientUser] = useState({
      clientName: "",
      email: "",
    });

    const [wishlistEmployees, setWishlistEmployees] = useState([]);
    const [wishlistEmployeeIds, setWishlistEmployeeIds] = useState(new Set()); // Track IDs for quick lookup

    // Real-time wishlist listener
    useEffect(() => {
      const storedUser = JSON.parse(localStorage.getItem("clientUser"));
      const clientId = storedUser?.clientId;
      if (!clientId) return;

      const wishlistRef = collection(db, "clients", clientId, "wishlist");

      const unsubscribe = onSnapshot(wishlistRef, async (snapshot) => {
        const employeeIds = new Set();
        const employees = [];

        for (const docSnap of snapshot.docs) {
          const employeeId = docSnap.id;
          employeeIds.add(employeeId);

          const employeeRef = doc(db, "employees", employeeId);
          const employeeSnap = await getDoc(employeeRef);
          if (employeeSnap.exists()) {
            employees.push({ id: employeeSnap.id, ...employeeSnap.data() });
          }
        }

        setWishlistEmployees(employees);
        setWishlistEmployeeIds(employeeIds);
      });

      // Add this function to handle menu navigation
      const handleMenuItemChange = (menuItem, employeeId = null) => {
        setActiveMenuItem(menuItem);
        if (employeeId) {
          setSelectedEmployeeId(employeeId);
        }
      };

      return () => unsubscribe();
    }, []);

    useEffect(() => {
      // Fetch clientUser from localStorage
      const storedUser = JSON.parse(localStorage.getItem("clientUser"));
      if (storedUser) {
        setClientUser({
          clientName: storedUser.clientName || "Unknown Client",
          email: storedUser.email || "No Email",
        });
      }
    }, []);

    // Add this useEffect to clear selected employee when tab changes
    useEffect(() => {
      setSelectedEmployeeId(null);
      setActiveMenuItem("employees"); // Reset to default menu item
    }, [activeTab]);

    const themeOptions = [
      { value: "light", label: "Original", icon: "☀️" },
      // { value: "dark", label: "Dark", icon: "🌙" },
      { value: "candy-green", label: "Candy Green", icon: "🍃" },
      { value: "candy-lightgreen", label: "Candy Light Green", icon: "🌿" },
      { value: "candy-blue", label: "Candy Blue", icon: "💧" },
      { value: "candy-blend", label: "Candy Blend", icon: "🌈" },
    ];

    const getCurrentThemeLabel = () => {
      const currentTheme = themeOptions.find((option) => option.value === theme);
      return currentTheme
        ? `${currentTheme.icon} ${currentTheme.label}`
        : "Select Theme";
    };

    const handleThemeChange = (themeValue) => {
      changeTheme(themeValue);
      setIsThemeDropdownOpen(false);
    };

    // Add this function to handle employee selection
    const handleEmployeeSelect = (employeeId) => {
      setSelectedEmployeeId(employeeId);
      console.log("Selected employee:", employeeId);
    };

    // Add this function to handle menu item changes
    const handleMenuItemChange = (menuItem) => {
      setActiveMenuItem(menuItem);
    };

    // Save employee to wishlist in Firestore
    const handleAddToWishlist = async (employee) => {
      try {
        const storedUser = JSON.parse(localStorage.getItem("clientUser"));
        const clientId = storedUser?.clientId;
        if (!clientId) {
          alert("You must be logged in to add to wishlist");
          return;
        }

        const employeeRef = doc(db, "clients", clientId, "wishlist", employee.id);

        await setDoc(employeeRef, {
          createdAt: new Date(),
        });

        console.log("✅ Employee added to wishlist:", employee);
        alert(`${employee.name} added to your wishlist!`);
      } catch (error) {
        console.error("❌ Error adding to wishlist:", error);
        alert("Something went wrong while adding to wishlist");
      }
    };

    // Remove employee from wishlist
    const handleRemoveFromWishlist = async (employeeId) => {
      try {
        const storedUser = JSON.parse(localStorage.getItem("clientUser"));
        const clientId = storedUser?.clientId;
        if (!clientId) return;

        // Delete from Firestore - the real-time listener will update the state
        const employeeRef = doc(db, "clients", clientId, "wishlist", employeeId);
        await deleteDoc(employeeRef);

        console.log("✅ Removed from wishlist:", employeeId);
      } catch (error) {
        console.error("❌ Error removing from wishlist:", error);
        alert("Failed to remove employee from wishlist");
      }
    };

    return (
      <div className={`client-dashboard theme-${theme}`}>
        {/* ✅ Mobile Header with Hamburger */}
        <div className="mobile-header">
          <button
            className="hamburger-btn"
            onClick={() => setIsSidebarOpen(true)}
          >
            <FiMenu size={22} />
          </button>
          <h2 className="mobile-title">Client Dashboard</h2>
        </div>
        {/* Sidebar */}
        <aside className={`side ${isSidebarOpen ? "open" : ""}`}>
          <button
            className="close-sidebar-btn"
            onClick={() => setIsSidebarOpen(false)}
          >
            <FiX size={22} />
          </button>
          <div className="side-header">
            <div className="logo">
              <a href="/client-dashboard" style={{ display: "inline-block" }}>
                <img
                  src={Logo}
                  alt="Two Seas Logo"
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "contain",
                    cursor: "pointer",
                  }}
                />
              </a>
              <h2>Two Seas | Client Portal</h2>
            </div>

            {/* Theme Controls */}
            <div className="theme-controls">
              <div className="theme-dropdown">
                <button
                  className="theme-dropdown-toggle"
                  onClick={() => setIsThemeDropdownOpen(!isThemeDropdownOpen)}
                >
                  <span>{getCurrentThemeLabel()}</span>
                  <FiChevronDown size={16} />
                </button>

                {isThemeDropdownOpen && (
                  <div className="theme-dropdown-menu">
                    {themeOptions.map((option) => (
                      <button
                        key={option.value}
                        className={`theme-dropdown-item ${
                          theme === option.value ? "active" : ""
                        }`}
                        onClick={() => handleThemeChange(option.value)}
                      >
                        <span className="theme-icon">{option.icon}</span>
                        <span>{option.label}</span>
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>

          <nav className="sideNav">
            <ul>
              <li className={activeTab === "employees" ? "active" : ""}>
                <button
                  onClick={() => {
                    setActiveTab("employees");
                    setIsSidebarOpen(false);
                    setSelectedEmployeeId(null);
                    setActiveMenuItem("employees");
                  }}
                >
                  <FiUsers size={18} />
                  Employees
                </button>
              </li>
              <li className={activeTab === "wishlist" ? "active" : ""}>
                <button
                  onClick={() => {
                    setActiveTab("wishlist");
                    setIsSidebarOpen(false);
                  }}
                >
                  <FiHeart size={18} />
                  Wishlist
                </button>
              </li>
              <li className={activeTab === "recommended" ? "active" : ""}>
                <button
                  onClick={() => {
                    setActiveTab("recommended");
                    setIsSidebarOpen(false);
                    setSelectedEmployeeId(null);
                    setActiveMenuItem("recommended");
                  }}
                >
                  <FiUsers size={18} />
                  Our Recommendations
                </button>
              </li>
              <li className={activeTab === "schedule" ? "active" : ""}>
                <button
                  onClick={() => {
                    setActiveTab("schedule");
                    setIsSidebarOpen(false);
                  }}
                >
                  <FiCalendar size={18} />
                  My Scheduled Interviews
                </button>
              </li>
            </ul>
          </nav>

          {/* User Profile Section */}
          <div className="user-profile">
            <div className="user-avatar">
              <FiUsers size={20} />
            </div>
            <div className="user-info">
              <p className="user-name">{clientUser.clientName}</p>
              <p className="user-role">{clientUser.email}</p>
            </div>
            <div style={{ width: "100%", textAlign: "right" }}>
              <LogOut
                onClick={() => handleLogout()}
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>
        </aside>

        {/* ✅ Overlay (for mobile) */}
        {isSidebarOpen && (
          <div
            className="sidebar-overlay"
            onClick={() => setIsSidebarOpen(false)}
          ></div>
        )}

        {/* Main */}
        <main className="main">
          <header className={`theme-${theme} dashboard-header`}>
            <h1>
              {/* {activeTab === "employees" && "Available Employees"} */}
              {activeTab === "employees"}
              {activeTab === "wishlist" && "Your Wishlist"}
              {activeTab === "schedule" && "My Scheduled Interviews"}
              {activeTab === "recommended" && "Our Recommended Employees"}
            </h1>
          </header>

          <div className="dashboard-content">
            {/* {activeTab === "employees" && (
              <>
                {activeMenuItem === "employees" && (
                  <div className="employees-list">
                    <EmployeeCard
                      archived={false}
                      setSelectedEmployeeId={setSelectedEmployeeId}
                      setActiveMenuItem={handleMenuItemChange}
                      visibilityFilter="client"
                      onAddToWishlist={handleAddToWishlist}
                      isInWishlist={(employeeId) =>
                        wishlistEmployeeIds.has(employeeId)
                      }
                    />
                  </div>
                )}

                {activeMenuItem === "employee-details" && selectedEmployeeId && (
                  <div className="employee-details-section">
                    <EmployeeDetail
                      employeeId={selectedEmployeeId}
                      onBack={() => handleMenuItemChange("employees")}
                      setActiveTab={setActiveTab} // ✅ add this
                      onAddToWishlist={handleAddToWishlist}
                      isInWishlist={(employeeId) =>
                        wishlistEmployeeIds.has(employeeId)
                      }
                    />
                  </div>
                )}
              </>
            )} */}
            {activeTab === "employees" && (
              <>
                {activeMenuItem === "employees" && (
                  <div className="employees-list">
                    <EmployeeCard
                      archived={false}
                      setSelectedEmployeeId={setSelectedEmployeeId}
                      setActiveMenuItem={handleMenuItemChange}
                      visibilityFilter="client"
                      onAddToWishlist={handleAddToWishlist}
                      isInWishlist={(employeeId) =>
                        wishlistEmployeeIds.has(employeeId)
                      }
                    />
                  </div>
                )}

                {activeMenuItem === "employee-details" &&
                  selectedEmployeeId && (
                    <div className="employee-details-section">
                      <EmployeeDetail
                        employeeId={selectedEmployeeId}
                        onBack={() => handleMenuItemChange("employees")} // This should work
                        onClose={() => handleMenuItemChange("employees")} // Add this too
                        onAddToWishlist={handleAddToWishlist}
                        isInWishlist={(employeeId) =>
                          wishlistEmployeeIds.has(employeeId)
                        }
                      />
                    </div>
                  )}
              </>
            )}

            {/* {activeTab === "wishlist" && (
              <div className="wishlist-section">
                {wishlistEmployees.length > 0 ? (
                  <div className="wishlist-grid">
                    {wishlistEmployees.map((employee) => (
                      <EmployeeCard
                        key={employee.id}
                        employee={employee}
                        archived={false}
                        setSelectedEmployeeId={setSelectedEmployeeId}
                        setActiveMenuItem={handleMenuItemChange}
                        visibilityFilter="client"
                        onRemoveFromWishlist={() =>
                          handleRemoveFromWishlist(employee.id)
                        }
                        showRemoveButton={true}
                      />
                    ))}
                  </div>
                ) : (
                  <div className="empty-state">
                    <FiHeart size={48} />
                    <h3>Your wishlist is empty</h3>
                    <p>
                      Start adding employees to your wishlist to keep track of
                      favorites
                    </p>
                  </div>
                )}
              </div>
            )} */}

            {/* {activeTab === "wishlist" && (
              <div className="wishlist-section">
                {selectedEmployeeId ? (
                  // Show employee detail when an employee is selected
                  <EmployeeDetail
                    employeeId={selectedEmployeeId}
                    setActiveTab={setActiveTab} // or whatever your tab setting function is
                    onBack={() => setSelectedEmployeeId(null)} // Add back functionality
                    onAddToWishlist={handleAddToWishlist} // Make sure this is defined
                    onRemoveFromWishlist={handleRemoveFromWishlist}
                    isInWishlist={(employeeId) =>
                      wishlistEmployees.some((emp) => emp.id === employeeId)
                    }
                    showRemoveButton={true}
                  />
                ) : (
                  // Show wishlist grid when no employee is selected
                  <>
                    {wishlistEmployees.length > 0 ? (
                      <div className="wishlist-grid">
                        {wishlistEmployees.map((employee) => (
                          <EmployeeCard
                            key={employee.id}
                            employee={employee}
                            archived={false}
                            setSelectedEmployeeId={setSelectedEmployeeId}
                            setActiveMenuItem={handleMenuItemChange}
                            visibilityFilter="client"
                            onRemoveFromWishlist={() =>
                              handleRemoveFromWishlist(employee.id)
                            }
                            showRemoveButton={true}
                          />
                        ))}
                      </div>
                    ) : (
                      <div className="empty-state">
                        <FiHeart size={48} />
                        <h3>Your wishlist is empty</h3>
                        <p>
                          Start adding employees to your wishlist to keep track of
                          favorites
                        </p>
                      </div>
                    )}
                  </>
                )}
              </div>
            )} */}
            {activeTab === "wishlist" && (
              <div className="wishlist-section">
                {selectedEmployeeId ? (
                  <EmployeeDetail
                    employeeId={selectedEmployeeId}
                    onClose={() => setSelectedEmployeeId(null)} // Use onClose here
                    onAddToWishlist={handleAddToWishlist}
                    onRemoveFromWishlist={handleRemoveFromWishlist}
                    isInWishlist={(employeeId) =>
                      wishlistEmployees.some((emp) => emp.id === employeeId)
                    }
                    showRemoveButton={true}
                  />
                ) : (
                  // Show wishlist grid
                  <>
                    {wishlistEmployees.length > 0 ? (
                      <div className="wishlist-grid">
                        {wishlistEmployees.map((employee) => (
                          <EmployeeCard
                            key={employee.id}
                            employee={employee}
                            archived={false}
                            setSelectedEmployeeId={setSelectedEmployeeId}
                            setActiveMenuItem={handleMenuItemChange}
                            visibilityFilter="client"
                            onRemoveFromWishlist={() =>
                              handleRemoveFromWishlist(employee.id)
                            }
                            showRemoveButton={true}
                          />
                        ))}
                      </div>
                    ) : (
                      <div className="empty-state">
                        <FiHeart size={48} />
                        <h3>Your wishlist is empty</h3>
                        <p>
                          Start adding employees to your wishlist to keep track
                          of favorites
                        </p>
                      </div>
                    )}
                  </>
                )}
              </div>
            )}

            {/* {activeTab === "schedule" && (
              // <div className="scheduler-section">
              //   <CalendarScheduler />
              // </div>
              <div style={{ overflowX: "auto" }}>
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    minWidth: "700px",
                  }}
                >
                  <thead>
                    <tr style={{ backgroundColor: "#f8fafc" }}>
                      <th
                        style={{
                          padding: "16px",
                          fontWeight: "600",
                          borderBottom: "1px solid #e5e7eb",
                        }}
                      >
                        Client
                      </th>
                      <th
                        style={{
                          padding: "16px",
                          fontWeight: "600",
                          borderBottom: "1px solid #e5e7eb",
                        }}
                      >
                        Employee
                      </th>
                      <th
                        style={{
                          padding: "16px",
                          fontWeight: "600",
                          borderBottom: "1px solid #e5e7eb",
                        }}
                      >
                        Primary Date & Time
                      </th>
                      <th
                        style={{
                          padding: "16px",
                          fontWeight: "600",
                          borderBottom: "1px solid #e5e7eb",
                        }}
                      >
                        Secondary Date & Time
                      </th>
                      <th
                        style={{
                          padding: "16px",
                          fontWeight: "600",
                          borderBottom: "1px solid #e5e7eb",
                        }}
                      >
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {interviews.map((interview) => (
                      <tr
                        key={interview.id}
                        style={{
                          borderBottom: "1px solid #f1f5f9",
                          transition: "all 0.2s",
                        }}
                        onMouseOver={(e) => {
                          e.currentTarget.style.backgroundColor = "#f8fafc";
                        }}
                        onMouseOut={(e) => {
                          e.currentTarget.style.backgroundColor = "white";
                        }}
                      >
                        <td style={{ padding: "16px" }}>
                          <div>
                            <div
                              style={{
                                fontWeight: "600",
                                color: "#374151",
                                fontSize: "14px",
                              }}
                            >
                              {interview.clientName}
                            </div>
                            <div
                              style={{
                                fontSize: "13px",
                                color: "#6b7280",
                                marginTop: "4px",
                              }}
                            >
                              {interview.clientUserEmail}
                            </div>
                          </div>
                        </td>
                        <td style={{ padding: "16px" }}>
                          <div>
                            <div
                              style={{
                                fontWeight: "500",
                                color: "#374151",
                                fontSize: "14px",
                              }}
                            >
                              {interview.employeeName}
                            </div>
                            <div
                              style={{
                                fontSize: "13px",
                                color: "#6b7280",
                                marginTop: "4px",
                              }}
                            >
                              {interview.employeeEmail}
                            </div>
                          </div>
                        </td>
                        <td
                          style={{
                            padding: "16px",
                            fontSize: "14px",
                            color: "#374151",
                          }}
                        >
                          {formatDateTime(
                            interview.primaryDate,
                            interview.primaryTime,
                            interview.primaryTimeZone
                          )}
                        </td>
                        <td
                          style={{
                            padding: "16px",
                            fontSize: "14px",
                            color: "#374151",
                          }}
                        >
                          {interview.alternateDate ? (
                            formatDateTime(
                              interview.alternateDate,
                              interview.alternateTime,
                              interview.alternateTimeZone
                            )
                          ) : (
                            <span
                              style={{ color: "#9ca3af", fontStyle: "italic" }}
                            >
                              Not provided
                            </span>
                          )}
                        </td>
                        <td
                          style={{
                            padding: "16px",
                            fontSize: "14px",
                            fontWeight: "500",
                          }}
                        >
                          <span
                            style={{
                              display: "inline-block",
                              padding: "4px 10px",
                              borderRadius: "8px",
                              backgroundColor:
                                interview.status === "confirmed"
                                  ? "#dcfce7" // light green
                                  : "#fef9c3", // light yellow for 'In Process'
                              color:
                                interview.status === "confirmed"
                                  ? "#166534" // dark green text
                                  : "#854d0e", // brownish text for 'In Process'
                              textTransform: "capitalize",
                              fontStyle: "normal",
                              fontWeight: "600",
                              border: "1px solid rgba(0, 0, 0, 0.05)",
                              boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                            }}
                          >
                            {interview.status || "In Process"}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )} */}
            {activeTab === "schedule" && (
              <div style={{ overflowX: "auto" }}>
                {interviews.length === 0 ? (
                  // Show message when no interviews
                  <div
                    style={{
                      textAlign: "center",
                      padding: "60px 20px",
                      backgroundColor: "white",
                      borderRadius: "12px",
                      boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <FiCalendar
                      size={48}
                      style={{ color: "#9ca3af", marginBottom: "16px" }}
                    />
                    <h3
                      style={{
                        color: "#374151",
                        marginBottom: "8px",
                        fontSize: "18px",
                        fontWeight: "600",
                      }}
                    >
                      No Scheduled Interviews
                    </h3>
                    <p
                      style={{
                        color: "#6b7280",
                        fontSize: "14px",
                        maxWidth: "400px",
                        margin: "0 auto",
                        lineHeight: "1.5",
                      }}
                    >
                      You don't have any scheduled interviews yet.
                    </p>
                  </div>
                ) : (
                  // Show table when interviews exist
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      minWidth: "700px",
                      backgroundColor: "white",
                      borderRadius: "12px",
                      overflow: "hidden",
                      boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <thead>
                      <tr style={{ backgroundColor: "#f8fafc" }}>
                        <th
                          style={{
                            padding: "16px",
                            fontWeight: "600",
                            borderBottom: "1px solid #e5e7eb",
                          }}
                        >
                          Client
                        </th>
                        <th
                          style={{
                            padding: "16px",
                            fontWeight: "600",
                            borderBottom: "1px solid #e5e7eb",
                          }}
                        >
                          Employee
                        </th>
                        <th
                          style={{
                            padding: "16px",
                            fontWeight: "600",
                            borderBottom: "1px solid #e5e7eb",
                          }}
                        >
                          Primary Date & Time
                        </th>
                        <th
                          style={{
                            padding: "16px",
                            fontWeight: "600",
                            borderBottom: "1px solid #e5e7eb",
                          }}
                        >
                          Secondary Date & Time
                        </th>
                        <th
                          style={{
                            padding: "16px",
                            fontWeight: "600",
                            borderBottom: "1px solid #e5e7eb",
                          }}
                        >
                          Status
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {interviews.map((interview) => (
                        <tr
                          key={interview.id}
                          style={{
                            borderBottom: "1px solid #f1f5f9",
                            transition: "all 0.2s",
                          }}
                          onMouseOver={(e) => {
                            e.currentTarget.style.backgroundColor = "#f8fafc";
                          }}
                          onMouseOut={(e) => {
                            e.currentTarget.style.backgroundColor = "white";
                          }}
                        >
                          <td style={{ padding: "16px" }}>
                            <div>
                              <div
                                style={{
                                  fontWeight: "600",
                                  color: "#374151",
                                  fontSize: "14px",
                                }}
                              >
                                {interview.clientName}
                              </div>
                              <div
                                style={{
                                  fontSize: "13px",
                                  color: "#6b7280",
                                  marginTop: "4px",
                                }}
                              >
                                {interview.clientUserEmail}
                              </div>
                            </div>
                          </td>
                          <td style={{ padding: "16px" }}>
                            <div>
                              <div
                                style={{
                                  fontWeight: "500",
                                  color: "#374151",
                                  fontSize: "14px",
                                }}
                              >
                                {interview.employeeName}
                              </div>
                              <div
                                style={{
                                  fontSize: "13px",
                                  color: "#6b7280",
                                  marginTop: "4px",
                                }}
                              >
                                {interview.employeeEmail}
                              </div>
                            </div>
                          </td>
                          {/* <td
                            style={{
                              padding: "16px",
                              fontSize: "14px",
                              color: "#374151",
                            }}
                          >
                            {formatDateTime(
                              interview.primaryDate,
                              interview.primaryTime,
                              interview.primaryTimeZone
                            )}
                          </td>
                          <td
                            style={{
                              padding: "16px",
                              fontSize: "14px",
                              color: "#374151",
                            }}
                          >
                            {interview.alternateDate ? (
                              formatDateTime(
                                interview.alternateDate,
                                interview.alternateTime,
                                interview.alternateTimeZone
                              )
                            ) : (
                              <span
                                style={{ color: "#9ca3af", fontStyle: "italic" }}
                              >
                                Not provided
                              </span>
                            )}
                          </td> */}
                          <td
                            style={{
                              padding: "16px",
                              fontSize: "14px",
                              color: "#374151",
                            }}
                          >
                            {formatDateTime(
                              interview.primaryDate,
                              interview.primaryTime,
                              interview.primaryTimeZone,
                              interview.primaryTimeDisplay, // Pass the display time
                            )}
                          </td>
                          <td
                            style={{
                              padding: "16px",
                              fontSize: "14px",
                              color: "#374151",
                            }}
                          >
                            {interview.alternateDate ? (
                              formatDateTime(
                                interview.alternateDate,
                                interview.alternateTime,
                                interview.alternateTimeZone,
                                interview.alternateTimeDisplay, // Pass the display time
                              )
                            ) : (
                              <span
                                style={{
                                  color: "#9ca3af",
                                  fontStyle: "italic",
                                }}
                              >
                                Not provided
                              </span>
                            )}
                          </td>
                          <td
                            style={{
                              padding: "16px",
                              fontSize: "14px",
                              fontWeight: "500",
                            }}
                          >
                            <span
                              style={{
                                display: "inline-block",
                                padding: "4px 10px",
                                borderRadius: "8px",
                                backgroundColor:
                                  interview.status === "confirmed"
                                    ? "#dcfce7" // light green
                                    : "#fef9c3", // light yellow for 'In Process'
                                color:
                                  interview.status === "confirmed"
                                    ? "#166534" // dark green text
                                    : "#854d0e", // brownish text for 'In Process'
                                textTransform: "capitalize",
                                fontStyle: "normal",
                                fontWeight: "600",
                                border: "1px solid rgba(0, 0, 0, 0.05)",
                                boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                              }}
                            >
                              {interview.status || "In Process"}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            )}

            {/* {activeTab === "schedule" && (
              <div style={{ overflowX: "auto" }}>
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    minWidth: "700px",
                  }}
                >
                  <thead>
                    <tr style={{ backgroundColor: "#f8fafc" }}>
                      <th
                        style={{
                          padding: "16px",
                          fontWeight: "600",
                          borderBottom: "1px solid #e5e7eb",
                        }}
                      >
                        Client
                      </th>
                      <th
                        style={{
                          padding: "16px",
                          fontWeight: "600",
                          borderBottom: "1px solid #e5e7eb",
                        }}
                      >
                        Employee
                      </th>
                      <th
                        style={{
                          padding: "16px",
                          fontWeight: "600",
                          borderBottom: "1px solid #e5e7eb",
                        }}
                      >
                        Primary Date & Time
                      </th>
                      <th
                        style={{
                          padding: "16px",
                          fontWeight: "600",
                          borderBottom: "1px solid #e5e7eb",
                        }}
                      >
                        Secondary Date & Time
                      </th>
                      <th
                        style={{
                          padding: "16px",
                          fontWeight: "600",
                          borderBottom: "1px solid #e5e7eb",
                        }}
                      >
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {interviews
                      .sort((a, b) => {
                        // Sort by primary date and time (newest first)
                        const dateA = new Date(
                          `${a.primaryDate}T${a.primaryTime}`
                        );
                        const dateB = new Date(
                          `${b.primaryDate}T${b.primaryTime}`
                        );
                        return dateB - dateA; // Newest first
                      })
                      .map((interview) => (
                        <tr
                          key={interview.id}
                          style={{
                            borderBottom: "1px solid #f1f5f9",
                            transition: "all 0.2s",
                          }}
                          onMouseOver={(e) => {
                            e.currentTarget.style.backgroundColor = "#f8fafc";
                          }}
                          onMouseOut={(e) => {
                            e.currentTarget.style.backgroundColor = "white";
                          }}
                        >
                          <td style={{ padding: "16px" }}>
                            <div>
                              <div
                                style={{
                                  fontWeight: "600",
                                  color: "#374151",
                                  fontSize: "14px",
                                }}
                              >
                                {interview.clientName}
                              </div>
                              <div
                                style={{
                                  fontSize: "13px",
                                  color: "#6b7280",
                                  marginTop: "4px",
                                }}
                              >
                                {interview.clientUserEmail}
                              </div>
                            </div>
                          </td>
                          <td style={{ padding: "16px" }}>
                            <div>
                              <div
                                style={{
                                  fontWeight: "500",
                                  color: "#374151",
                                  fontSize: "14px",
                                }}
                              >
                                {interview.employeeName}
                              </div>
                              <div
                                style={{
                                  fontSize: "13px",
                                  color: "#6b7280",
                                  marginTop: "4px",
                                }}
                              >
                                {interview.employeeEmail}
                              </div>
                            </div>
                          </td>
                          <td
                            style={{
                              padding: "16px",
                              fontSize: "14px",
                              color: "#374151",
                            }}
                          >
                            {formatDateTime(
                              interview.primaryDate,
                              interview.primaryTime,
                              interview.primaryTimeZone
                            )}
                          </td>
                          <td
                            style={{
                              padding: "16px",
                              fontSize: "14px",
                              color: "#374151",
                            }}
                          >
                            {interview.alternateDate ? (
                              formatDateTime(
                                interview.alternateDate,
                                interview.alternateTime,
                                interview.alternateTimeZone
                              )
                            ) : (
                              <span
                                style={{ color: "#9ca3af", fontStyle: "italic" }}
                              >
                                Not provided
                              </span>
                            )}
                          </td>
                          <td
                            style={{
                              padding: "16px",
                              fontSize: "14px",
                              fontWeight: "500",
                            }}
                          >
                            <span
                              style={{
                                display: "inline-block",
                                padding: "4px 10px",
                                borderRadius: "8px",
                                backgroundColor:
                                  interview.status === "confirmed"
                                    ? "#dcfce7" // light green
                                    : "#fef9c3", // light yellow for 'In Process'
                                color:
                                  interview.status === "confirmed"
                                    ? "#166534" // dark green text
                                    : "#854d0e", // brownish text for 'In Process'
                                textTransform: "capitalize",
                                fontStyle: "normal",
                                fontWeight: "600",
                                border: "1px solid rgba(0, 0, 0, 0.05)",
                                boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                              }}
                            >
                              {interview.status || "In Process"}
                            </span>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            )} */}

            {/* {activeTab === "recommended" && (
              <div className="recommended-section" style={{ padding: "24px" }}>
                {recommendedEmployees.length > 0 ? (
                  <EmployeeCard
                    archived={false}
                    visibilityFilter="client"
                    currentClientId={clientUser.clientId}
                    setActiveMenuItem={setActiveMenuItem}
                    setSelectedEmployeeId={setSelectedEmployeeId}
                    recommendedIds={recommendedEmployees.map(emp => emp.id)} // 👈 pass recommended list
                    onAddToWishlist={handleAddToWishlist}
                    isInWishlist={(employeeId) => wishlistEmployeeIds.has(employeeId)}
                  />
                ) : (
                  <div style={{ textAlign: "center", padding: "40px", color: "#9ca3af" }}>
                    No recommended employees found.
                  </div>
                )}
              </div>
            )} */}

            {/* {activeTab === "recommended" && (
              <>
                {activeMenuItem !== "employee-details" && (
                  <div
                    className="recommended-section"
                    style={{ padding: "24px" }}
                  >
                    {recommendedEmployees.length > 0 ? (
                      <EmployeeCard
                        archived={false}
                        visibilityFilter="client"
                        currentClientId={clientUser.clientId}
                        setActiveMenuItem={setActiveMenuItem}
                        setSelectedEmployeeId={setSelectedEmployeeId}
                        recommendedIds={recommendedEmployees.map((emp) => emp.id)}
                        onAddToWishlist={handleAddToWishlist}
                        isInWishlist={(employeeId) =>
                          wishlistEmployeeIds.has(employeeId)
                        }
                      />
                    ) : (
                      <div
                        style={{
                          textAlign: "center",
                          padding: "40px",
                          color: "#9ca3af",
                        }}
                      >
                        No recommended employees found.
                      </div>
                    )}
                  </div>
                )}

                {activeMenuItem === "employee-details" && selectedEmployeeId && (
                  <div className="employee-details-section">
                    <EmployeeDetail
                      employeeId={selectedEmployeeId}
                      onBack={() => setActiveMenuItem("recommended")}
                      setActiveTab={setActiveTab}
                      onAddToWishlist={handleAddToWishlist}
                      isInWishlist={(employeeId) =>
                        wishlistEmployeeIds.has(employeeId)
                      }
                    />
                  </div>
                )}
              </>
            )} */}
            {activeTab === "recommended" && (
              <>
                {activeMenuItem !== "employee-details" && (
                  <div
                    className="recommended-section"
                    style={{ padding: "24px" }}
                  >
                    {recommendedEmployees.length > 0 ? (
                      <EmployeeCard
                        archived={false}
                        visibilityFilter="client"
                        currentClientId={clientUser.clientId}
                        setActiveMenuItem={setActiveMenuItem}
                        setSelectedEmployeeId={setSelectedEmployeeId}
                        recommendedIds={recommendedEmployees.map(
                          (emp) => emp.id,
                        )}
                        onAddToWishlist={handleAddToWishlist}
                        isInWishlist={(employeeId) =>
                          wishlistEmployeeIds.has(employeeId)
                        }
                      />
                    ) : (
                      <div
                        style={{
                          textAlign: "center",
                          padding: "40px",
                          color: "#9ca3af",
                        }}
                      >
                        No recommended employees found.
                      </div>
                    )}
                  </div>
                )}

                {activeMenuItem === "employee-details" &&
                  selectedEmployeeId && (
                    <div className="employee-details-section">
                      <EmployeeDetail
                        employeeId={selectedEmployeeId}
                        onBack={() => setActiveMenuItem("recommended")}
                        onClose={() => setActiveMenuItem("recommended")} // Add this
                        onAddToWishlist={handleAddToWishlist}
                        isInWishlist={(employeeId) =>
                          wishlistEmployeeIds.has(employeeId)
                        }
                      />
                    </div>
                  )}
              </>
            )}
          </div>
        </main>
      </div>
    );
  }
